import { useDebugValue, useEffect } from 'react';
import { useMeasureElementCookieState } from './useMeasureElementCookieState';
import { useMeasureElement } from './useMeasureElement';
export function useMeasureElementCookie(cookieType, { defaultSize: defaultSizeProp, cookieDim = 'both', version = 0, measureOptions }) {
    const { containerSize, defaultSizeForPlatform, updateContainerSize } = useMeasureElementCookieState(cookieType, cookieDim, defaultSizeProp, {
        throttle: 0,
        throttleOptions: {}
    });
    useDebugValue(containerSize, (size)=>`Width: ${size === null || size === void 0 ? void 0 : size.width}, height: ${size === null || size === void 0 ? void 0 : size.height}`);
    const { ref, dimensions } = useMeasureElement(measureOptions !== null && measureOptions !== void 0 ? measureOptions : {
        throttle: 250,
        throttleOptions: {
            trailing: true
        }
    });
    useEffect(()=>{
        updateContainerSize(dimensions);
    }, [
        dimensions,
        updateContainerSize
    ]);
    return {
        ref,
        dimensions: containerSize !== null && containerSize !== void 0 ? containerSize : defaultSizeForPlatform
    };
}
